export const SCALE_LIMIT = [0.5, 4] as const;

export const DEFAULT_MAP_CONFIG = {
  fullscreen: false,
  fitted: true,
  autostart: true,
  smoothing: true,
} as const;

export const NODE_STYLE_CLASS = {
  CAMP: 'glc-camp-node',
  LAKE: 'glc-lake-node',
  TREE: 'glc-tree-node',
  PATH: 'glc-path-node',
};

export const MAP_INTERACTIVE = window.appConfigs.interactableMap ?? false;
